module.exports = __webpack_public_path__ + "img/NL600.c2530649.png";